// extracted by mini-css-extract-plugin
export default {"cls1":"BankLookupBody-Grid_cls1__d0oOg","cls2":"BankLookupBody-Grid_cls2__LxDdV BankLookupBody-Grid_cls1__d0oOg"};